export function isProductionDomain(): boolean {
  if (typeof window === 'undefined') return false

  const productionDomain = process.env.NEXT_PUBLIC_CAPTCHA_PRODUCTION_DOMAIN
  if (!productionDomain) return false

  const hostname = window.location.hostname
  return hostname === productionDomain || hostname.endsWith(`.${productionDomain}`)
}

/**
 * Verifies a Cloudflare Turnstile token
 * @param token - The Turnstile token to verify
 * @returns true if verification succeeds, false otherwise
 */
export async function verifyCaptcha(token: string): Promise<boolean> {
  try {
    const secretKey = process.env.CF_CAPTCHA_SECRET_KEY

    if (!secretKey) {
      console.error('CF_CAPTCHA_SECRET_KEY is not configured')
      return false
    }

    const response = await fetch('https://challenges.cloudflare.com/turnstile/v0/siteverify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        secret: secretKey,
        response: token,
      }),
    })

    const data = await response.json()

    if (!data.success) {
      console.error('Cloudflare Turnstile verification failed:', data['error-codes'])
    }

    return data.success
  } catch (error) {
    console.error('Cloudflare Turnstile verification error:', error)
    return false
  }
}
